import {Module, NextModule} from '@backstage-components/base';
import React from 'react';
import {ContainerLayout, ContainerLayoutDefinition} from './ContainerLayout';
import {ComponentDefinition} from './ContainerLayoutDefinition';

type Kind = ContainerLayoutDefinition['component'];

type Props = ContainerLayoutDefinition['props'];

export const ContainerLayoutModule: Module<Kind, Props> = {
  isContent(value): value is ContainerLayoutDefinition {
    return false;
  },
  isLayout(value): value is ContainerLayoutDefinition {
    return (
      value.component === ComponentDefinition.reactName &&
      value.cid === ComponentDefinition.id
    );
  },
  tryRender(definition) {
    if (ContainerLayoutModule.isLayout(definition)) {
      return React.createElement(ContainerLayout, definition);
    } else {
      return NextModule;
    }
  },
};
